import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { FC, useState } from 'react';
import { isEmpty, orderBy, get } from 'lodash';
import { injectIntl, IntlShape } from 'react-intl';
import moment from 'moment';
import { DATE_FORMAT } from 'constants/global';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import {
  EMPTY_CIVIL_PROCEEDING_INFO_FIELDS,
  CIVIL_PROCEEDING_INFORMATIONS_FIELDS,
} from 'containers/data-structure';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import { CivilProceedingInfo } from 'containers/LawyerLegalProceedingsPage/typings';
import { Config, Listings } from 'containers/AppContainer/typings';
import { getDateIgnoreTimezone } from 'containers/common/LegalProceedings/utils';
import { validationCourtFileNumber } from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';

interface RequestProps {
  intl: IntlShape;
  listings: Listings;
  info: CivilProceedingInfo;
  setCivilProceedingInfo: Function;
  isUpdated?: boolean;
  setIsUpdated?: Function;
  readOnly?: boolean;
}

const Request: FC<RequestProps> = props => {
  const { receptionDate, courtNumber, opposingLawyer, town } = props.info;

  const { listings } = props;
  const [updatedCivilProceedingInfo, setUpdatedCivilProceedingInfo] = useState({
    ...EMPTY_CIVIL_PROCEEDING_INFO_FIELDS,
  });
  /* istanbul ignore next */
  const handleChange = (field: string) => (
    event: React.ChangeEvent<{ name?: string | undefined; value: any }>,
  ) => {
    setUpdatedCivilProceedingInfo({
      ...updatedCivilProceedingInfo,
      [field]: event.target.value,
    });
    props.setCivilProceedingInfo({
      ...props.info,
      [field]: event.target.value,
    });
    props.setIsUpdated && props.setIsUpdated(true);
  };
  /* istanbul ignore next */
  const handleChangeDate = (date: Date | null) => {
    const theDate = getDateIgnoreTimezone(date);
    const receiptRequestDate = moment(theDate as Date).format(DATE_FORMAT);
    props.setCivilProceedingInfo({
      ...props.info,
      receptionDate: receiptRequestDate,
    });
    setUpdatedCivilProceedingInfo({
      ...updatedCivilProceedingInfo,
      dateReceiptRequest: receiptRequestDate,
    });
    props.setIsUpdated && props.setIsUpdated(true);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={3}>
        <TextField
          fullWidth
          id="judgement_number_field"
          label={translate(messages.opposingLawyerField, props)}
          onChange={handleChange(
            CIVIL_PROCEEDING_INFORMATIONS_FIELDS.OPPOSING_LAWYER,
          )}
          className="input"
          name={CIVIL_PROCEEDING_INFORMATIONS_FIELDS.OPPOSING_LAWYER}
          value={opposingLawyer}
          disabled={props.readOnly}
        />
      </Grid>
      <Grid item xs={3}>
        <FormControl fullWidth>
          <InputLabel id="idd-label-id">
            {translate(messages.town, props)}
          </InputLabel>
          <Select
            labelId="idd-label-id"
            onChange={handleChange(CIVIL_PROCEEDING_INFORMATIONS_FIELDS.TOWN)}
            name={CIVIL_PROCEEDING_INFORMATIONS_FIELDS.TOWN}
            value={town}
            disabled={props.readOnly}
          >
            {!isEmpty(listings.jurisdiction) &&
              /* istanbul ignore next */
              orderBy(
                get(props.listings, 'jurisdiction', []),
                [/* istanbul ignore next */ el => el?.title?.toLowerCase()],
                ['asc'],
              ).map(
                /* istanbul ignore next */ (el: Config) => (
                  /* istanbul ignore next */
                  <MenuItem key={el.id} value={el.id.toString()}>
                    {el.title}
                  </MenuItem>
                ),
              )}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          label={translate(messages.courtFile, props)}
          value={courtNumber}
          onChange={handleChange(
            CIVIL_PROCEEDING_INFORMATIONS_FIELDS.COURT_NUMBER,
          )}
          placeholder={'NNNNNN/NNNN/NNNN'}
          error={!validationCourtFileNumber(courtNumber)}
          helperText={
            !validationCourtFileNumber(courtNumber)
              ? translate(messages.courtFileNumberError, props)
              : ''
          }
          disabled={props.readOnly}
        />
      </Grid>
      <Grid item xs={3}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
          <KeyboardDatePicker
            autoOk
            fullWidth
            variant="inline"
            invalidDateMessage={
              '' // add error
            }
            format="dd/MM/yyyy"
            id="date-picker-inline-victim-date-of-birth"
            label={translate({ ...messages.dateReceiptRequestField }, props)}
            className="input"
            name={CIVIL_PROCEEDING_INFORMATIONS_FIELDS.DATE_RECEIPT_REQUEST}
            value={dateStringToLocalDate(receptionDate)}
            onChange={handleChangeDate}
            disabled={props.readOnly}
          />
        </MuiPickersUtilsProvider>
      </Grid>
    </Grid>
  );
};

export default injectIntl(Request);
